import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { UpgradeContentItemDocument } from './upgrade.generated';

export const useUpgradeContentItem = (
  options: ApiOptions<typeof UpgradeContentItemDocument> = {},
) => {
  const { t } = useTranslation();
  return useMutation(UpgradeContentItemDocument, {
    ...useNotifications(UpgradeContentItemDocument, {
      failure: t('api.content_items.upgrade_error'),
      success: t('api.content_items.upgrade_success'),
    }),

    ...options,
  });
};

export { UpgradeContentItemDocument } from './upgrade.generated';
